import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <div className="about-hero">
        <div className="about-hero-text">
          <p>
            isanroute is a fashion and lifestyle store with a speciality
            café focused on useful pieces, lasting materials and thoughtful service.
          </p>
          <p>
            Established in 2007 as a menswear-focused space, the store has since
            evolved to offer a carefully curated selection of both men's and
            women's fashion, lifestyle goods, and homewares. Our edit focuses
            on quality, utility and lasting character.
          </p>
          <p>
            On the ground floor, our speciality café serves an ever-changing
            line-up of renowned international coffee roasters, offering a
            dynamic espresso menu and a growing range of filter coffee options.
          </p>
        </div>
      </div>
      <div className="about-images">
        <img src="/generated/editorial/scene-33.webp" alt="isanroute exterior" />
        <img src="/generated/editorial/scene-34.webp" alt="Speciality cafe interior" />
      </div>
    </div>
  );
}

export default About;
